import { TFunction } from 'i18next';

import { ENERGY_SOURCE } from '../../../../../PcfWizard.type';

export const getEnergySourceOptions = (t: TFunction): { name: string; value: ENERGY_SOURCE }[] => {
  return [
    {
      name: t(
        'footprintDetailsPage.sections.calculatePcfSection.individualProcessSection.inputs.energySourceOptions.electricity',
      ),
      value: ENERGY_SOURCE.ELECTRICITY,
    },
    {
      name: t(
        'footprintDetailsPage.sections.calculatePcfSection.individualProcessSection.inputs.energySourceOptions.compressedAir',
      ),
      value: ENERGY_SOURCE.COMPRESSED_AIR,
    },
    {
      name: t(
        'footprintDetailsPage.sections.calculatePcfSection.individualProcessSection.inputs.energySourceOptions.gas',
      ),
      value: ENERGY_SOURCE.GAS,
    },
    {
      name: t(
        'footprintDetailsPage.sections.calculatePcfSection.individualProcessSection.inputs.energySourceOptions.fuel',
      ),
      value: ENERGY_SOURCE.FUEL,
    },
  ];
};
